import Icon from "./IconBase.js";
const ReportStudentIcon = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.5 14H12.5V0H0.5L3.4 4.5L0.5 9H11.5V14Z" fill="#B32306" />
      </svg>
    </Icon>
  );
};
export default ReportStudentIcon;
